import { useState, useEffect } from "react";
import { listTables, changePassword } from "./services/api";
import TableExplorer from "./components/TableExplorer";
import QueryEditor from "./components/QueryEditor";
import ReportView from "./components/ReportView";
import AliciBorcReport from "./components/AliciBorcReport";
import SaticiAlacakReport from "./components/SaticiAlacakReport";
import NakitAkisReport from "./components/NakitAkisReport";
import DestekSozlesme from "./components/DestekSozlesme";
import StokGelirGider from "./components/StokGelirGider";
import CariEkstre from "./components/CariEkstre";
import DestekKayitlari from "./components/DestekKayitlari";
import Anasayfa from "./components/Anasayfa";
import CrmModule from "./components/CrmModule";
import SAVED_REPORTS from "./reports";
import logo from "./assets/logo.png";
import logoDark from "./assets/logo-dark.png";

const CUSTOM_COMPONENTS = {
  "alici-borc":    AliciBorcReport,
  "satici-alacak": SaticiAlacakReport,
  "nakit-akis":    NakitAkisReport,
  "destek-sozlesme": DestekSozlesme,
};

const HOME_NAV = { id: "anasayfa", label: "Ana Sayfa", icon: "🏠" };

const REPORT_NAV = SAVED_REPORTS.map((r) => ({ id: r.id, label: r.name, icon: r.icon }));

const PRIMARY_NAV = [
  { id: "crm",      label: "CRM",                 icon: "🤝" },
  { id: "sozlesme", label: "Destek Sozlesmeleri", icon: "📋" },
  { id: "kayitlar", label: "Cubicl",              icon: "🗂️" },
  { id: "stok-gc",  label: "Gelir / Gider",       icon: "💰" },
  { id: "ekstre",   label: "Cari Hesap Ekstresi", icon: "📄" },
];

const OTHER_MODULES_NAV = [
  { id: "tables", label: "Tablolar",  icon: "🗃" },
  { id: "query",  label: "SQL Sorgu", icon: "🔍" },
];

const ALL_NAV = [HOME_NAV, ...REPORT_NAV, ...PRIMARY_NAV, ...OTHER_MODULES_NAV];

const SIDEBAR_KEY = "emk-sidebar-collapsed";

function NavButton({ item, active, collapsed, onClick, indent }) {
  return (
    <button
      onClick={onClick}
      title={collapsed ? item.label : undefined}
      style={{
        display: "flex", alignItems: "center", gap: collapsed ? 0 : 8,
        justifyContent: collapsed ? "center" : "flex-start",
        width: "100%", textAlign: "left",
        padding: collapsed ? "9px 0" : `9px 12px 9px ${indent ?? 12}px`, borderRadius: 7, border: "none",
        background: active ? "var(--accent-bg)" : "transparent",
        color: active ? "var(--accent-text)" : "var(--text-secondary)",
        cursor: "pointer", fontSize: 14,
        fontWeight: active ? 600 : 400,
        marginBottom: 2,
        overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",
      }}
    >
      <span>{item.icon}</span>
      {!collapsed && <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{item.label}</span>}
    </button>
  );
}

function ChangePasswordModal({ kullaniciAdi, onClose }) {
  const [eskiSifre, setEskiSifre] = useState("");
  const [yeniSifre, setYeniSifre] = useState("");
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const uyusmuyor = yeniSifre && yeniSifreTekrar && yeniSifre !== yeniSifreTekrar;
  const gecersiz = !eskiSifre || !yeniSifre || yeniSifre.length < 4 || yeniSifre !== yeniSifreTekrar;

  async function handleSubmit(e) {
    e.preventDefault();
    if (gecersiz) return;
    setLoading(true);
    setError(null);
    try {
      await changePassword(kullaniciAdi, eskiSifre, yeniSifre);
      setSuccess(true);
      setTimeout(onClose, 1500);
    } catch (e2) {
      setError(e2.response?.data?.detail || e2.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }} onClick={onClose}>
      <form
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
        style={{ width: 380, background: "var(--bg-page)", border: "1px solid var(--border)", borderRadius: 12, padding: 26, boxShadow: "0 25px 50px rgba(0,0,0,0.5)" }}
      >
        <div style={{ fontSize: 15, fontWeight: 600, color: "var(--accent-text)", marginBottom: 18 }}>🔑 Şifre Değiştir</div>

        {success ? (
          <div style={{ fontSize: 13, color: "#86efac" }}>Şifreniz güncellendi.</div>
        ) : (
          <>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Eski Şifre</div>
              <input
                autoFocus
                type="password"
                value={eskiSifre}
                onChange={(e) => setEskiSifre(e.target.value)}
                style={{ width: "100%", background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "9px 12px", color: "var(--text-primary)", fontSize: 13, outline: "none", boxSizing: "border-box" }}
              />
            </div>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Yeni Şifre</div>
              <input
                type="password"
                value={yeniSifre}
                onChange={(e) => setYeniSifre(e.target.value)}
                style={{ width: "100%", background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "9px 12px", color: "var(--text-primary)", fontSize: 13, outline: "none", boxSizing: "border-box" }}
              />
            </div>
            <div style={{ marginBottom: 8 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Yeni Şifre (Tekrar)</div>
              <input
                type="password"
                value={yeniSifreTekrar}
                onChange={(e) => setYeniSifreTekrar(e.target.value)}
                style={{ width: "100%", background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "9px 12px", color: "var(--text-primary)", fontSize: 13, outline: "none", boxSizing: "border-box" }}
              />
            </div>
            {uyusmuyor && <div style={{ fontSize: 12, color: "#fca5a5", marginBottom: 12 }}>Yeni şifreler eşleşmiyor.</div>}
            {error && <div style={{ background: "#450a0a", border: "1px solid #7f1d1d", borderRadius: 7, padding: "9px 12px", color: "#fca5a5", fontSize: 13, marginBottom: 14, marginTop: 4 }}>{error}</div>}

            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 18 }}>
              <button type="button" onClick={onClose} style={{ padding: "9px 18px", borderRadius: 7, border: "1px solid var(--border)", background: "transparent", color: "var(--text-muted)", fontSize: 13, cursor: "pointer" }}>
                İptal
              </button>
              <button
                type="submit"
                disabled={gecersiz || loading}
                style={{
                  padding: "9px 20px", borderRadius: 7, border: "none",
                  background: gecersiz || loading ? "var(--border)" : "#1d4ed8",
                  color: gecersiz || loading ? "var(--text-muted)" : "#fff",
                  fontSize: 13, fontWeight: 600, cursor: gecersiz || loading ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "⏳ Kaydediliyor..." : "Güncelle"}
              </button>
            </div>
          </>
        )}
      </form>
    </div>
  );
}

export default function App({ currentUser, onLogout, theme, onToggleTheme }) {
  const [nav, setNav] = useState(HOME_NAV.id);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [search, setSearch] = useState("");
  const [loadingTables, setLoadingTables] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);

  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(SIDEBAR_KEY) === "1");

  useEffect(() => {
    localStorage.setItem(SIDEBAR_KEY, collapsed ? "1" : "0");
  }, [collapsed]);

  useEffect(() => {
    if (nav === "tables" || nav === "query") setOtherOpen(true);
  }, [nav]);

  useEffect(() => {
    setLoadingTables(true);
    listTables()
      .then((r) => setTables(r.data))
      .catch(() => {})
      .finally(() => setLoadingTables(false));
  }, []);

  const filteredTables = tables.filter(
    (t) =>
      t.TABLE_NAME.toLowerCase().includes(search.toLowerCase()) ||
      t.TABLE_SCHEMA.toLowerCase().includes(search.toLowerCase())
  );

  const activeReport = SAVED_REPORTS.find((r) => r.id === nav);

  function headerTitle() {
    if (nav === "anasayfa") return "Ana Sayfa";
    if (activeReport) return activeReport.name;
    if (nav === "query") return "SQL Sorgu Editörü";
    if (nav === "tables") return selectedTable ? `${selectedTable.schema}.${selectedTable.table}` : "Tablo Seçin";
    if (nav === "crm") return "CRM";
    if (nav === "sozlesme") return "Destek Sözleşmeleri";
    if (nav === "kayitlar") return "Cubicl";
    if (nav === "stok-gc") return "Gelir / Gider";
    if (nav === "ekstre") return "Cari Hesap Ekstresi";
    return "";
  }

  return (
    <div style={{ display: "flex", height: "100vh", background: "var(--bg-page)", color: "var(--text-primary)", fontFamily: "Inter, system-ui, sans-serif" }}>
      {showPasswordModal && (
        <ChangePasswordModal kullaniciAdi={currentUser} onClose={() => setShowPasswordModal(false)} />
      )}

      {/* ── Sidebar ── */}
      <aside style={{ width: collapsed ? 64 : 260, background: "var(--bg-sidebar)", borderRight: "1px solid var(--border-hairline)", display: "flex", flexDirection: "column", flexShrink: 0, transition: "width 0.15s ease" }}>

        {/* Logo + collapse toggle */}
        <div style={{ padding: collapsed ? "16px 8px 12px" : "14px 16px", borderBottom: "1px solid var(--border-hairline)", display: "flex", alignItems: "center", justifyContent: collapsed ? "center" : "space-between", gap: 8 }}>
          {!collapsed && (
            <img src={theme === "dark" ? logoDark : logo} alt="EMK Yazılım" style={{ height: 40, width: "auto", display: "block" }} />
          )}
          <button
            onClick={() => setCollapsed((c) => !c)}
            title={collapsed ? "Menüyü genişlet" : "Menüyü daralt"}
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              width: 28, height: 28, borderRadius: 6, border: "1px solid var(--border)",
              background: "transparent", color: "var(--text-secondary)", cursor: "pointer", fontSize: 14, flexShrink: 0,
            }}
          >
            {collapsed ? "»" : "«"}
          </button>
        </div>

        {/* Nav */}
        <div style={{ padding: "8px 8px 0", flex: nav === "tables" && !collapsed ? undefined : 1, overflowY: "auto" }}>
          {collapsed ? (
            ALL_NAV.map((item) => (
              <NavButton key={item.id} item={item} active={nav === item.id} collapsed onClick={() => setNav(item.id)} />
            ))
          ) : (
            <>
              <NavButton item={HOME_NAV} active={nav === HOME_NAV.id} onClick={() => setNav(HOME_NAV.id)} />
              {[...REPORT_NAV, ...PRIMARY_NAV].map((item) => (
                <NavButton key={item.id} item={item} active={nav === item.id} onClick={() => setNav(item.id)} />
              ))}

              <button
                onClick={() => setOtherOpen((o) => !o)}
                style={{
                  display: "flex", alignItems: "center", gap: 8, width: "100%", textAlign: "left",
                  padding: "9px 12px", borderRadius: 7, border: "none", background: "transparent",
                  color: "var(--text-secondary)", cursor: "pointer", fontSize: 14, marginBottom: 2, marginTop: 6,
                }}
              >
                <span>🧩</span>
                <span style={{ flex: 1 }}>Diğer Modüller</span>
                <span style={{ fontSize: 11, color: "var(--text-faint)" }}>{otherOpen ? "▾" : "▸"}</span>
              </button>
              {otherOpen && OTHER_MODULES_NAV.map((item) => (
                <NavButton key={item.id} item={item} active={nav === item.id} onClick={() => setNav(item.id)} indent={30} />
              ))}
            </>
          )}
        </div>

        {/* ── Tablo Listesi ── */}
        {!collapsed && nav === "tables" && (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", padding: "8px 8px 0" }}>
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Tablo ara..."
              style={{
                background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7,
                padding: "7px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", marginBottom: 6,
              }}
            />
            <div style={{ overflowY: "auto", flex: 1 }}>
              {loadingTables && <div style={{ color: "var(--text-faint)", fontSize: 13, padding: "8px 4px" }}>Yükleniyor...</div>}
              {filteredTables.map((t) => {
                const key = `${t.TABLE_SCHEMA}.${t.TABLE_NAME}`;
                const isSelected = selectedTable?.schema === t.TABLE_SCHEMA && selectedTable?.table === t.TABLE_NAME;
                return (
                  <button
                    key={key}
                    onClick={() => setSelectedTable({ schema: t.TABLE_SCHEMA, table: t.TABLE_NAME })}
                    style={{
                      display: "block", width: "100%", textAlign: "left",
                      padding: "8px 10px", borderRadius: 6, border: "none",
                      background: isSelected ? "var(--accent-bg)" : "transparent",
                      color: isSelected ? "var(--accent-text)" : "var(--text-secondary)",
                      cursor: "pointer", fontSize: 13, marginBottom: 1,
                    }}
                  >
                    <div style={{ fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.TABLE_NAME}</div>
                    <div style={{ fontSize: 11, color: "var(--text-faint)" }}>{t.TABLE_SCHEMA}</div>
                  </button>
                );
              })}
              {!loadingTables && filteredTables.length === 0 && (
                <div style={{ color: "var(--text-faint)", fontSize: 13, padding: "8px 4px" }}>
                  {tables.length === 0 ? "Tablo bulunamadı" : "Sonuç yok"}
                </div>
              )}
            </div>
          </div>
        )}

        {/* ── Kullanıcı ── */}
        <div style={{ padding: 8, borderTop: "1px solid var(--border-hairline)", flexShrink: 0 }}>
          {!collapsed && (
            <div style={{ padding: "4px 12px 8px", fontSize: 12, color: "var(--text-faint)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              👤 {currentUser}
            </div>
          )}
          <button
            onClick={() => setShowPasswordModal(true)}
            title={collapsed ? "Şifre Değiştir" : undefined}
            style={{
              display: "flex", alignItems: "center", gap: collapsed ? 0 : 8,
              justifyContent: collapsed ? "center" : "flex-start",
              width: "100%", padding: collapsed ? "9px 0" : "9px 12px", borderRadius: 7,
              border: "none", background: "transparent", color: "var(--text-secondary)",
              cursor: "pointer", fontSize: 14, marginBottom: 2,
            }}
          >
            <span>🔑</span>
            {!collapsed && <span>Şifre Değiştir</span>}
          </button>
          <button
            onClick={onLogout}
            title={collapsed ? "Çıkış Yap" : undefined}
            style={{
              display: "flex", alignItems: "center", gap: collapsed ? 0 : 8,
              justifyContent: collapsed ? "center" : "flex-start",
              width: "100%", padding: collapsed ? "9px 0" : "9px 12px", borderRadius: 7,
              border: "none", background: "transparent", color: "var(--text-secondary)",
              cursor: "pointer", fontSize: 14,
            }}
          >
            <span>🚪</span>
            {!collapsed && <span>Çıkış Yap</span>}
          </button>
        </div>

        {/* ── Tema Anahtarı ── */}
        <div style={{ padding: 8, borderTop: "1px solid var(--border-hairline)", flexShrink: 0 }}>
          <button
            onClick={onToggleTheme}
            title={theme === "dark" ? "Aydınlık moda geç" : "Karanlık moda geç"}
            style={{
              display: "flex", alignItems: "center", gap: collapsed ? 0 : 8,
              justifyContent: collapsed ? "center" : "flex-start",
              width: "100%", padding: collapsed ? "9px 0" : "9px 12px", borderRadius: 7,
              border: "none", background: "transparent", color: "var(--text-secondary)",
              cursor: "pointer", fontSize: 14,
            }}
          >
            <span>{theme === "dark" ? "🌙" : "☀️"}</span>
            {!collapsed && <span>{theme === "dark" ? "Karanlık Mod" : "Aydınlık Mod"}</span>}
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <main style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <header style={{ padding: "16px 28px", borderBottom: "1px solid var(--border-hairline)", background: "var(--bg-sidebar)", flexShrink: 0 }}>
          <h1 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "var(--text-primary)" }}>{headerTitle()}</h1>
        </header>

        <div style={{ flex: 1, overflowY: "auto", padding: 28 }}>
          {nav === "anasayfa" && <Anasayfa onNavigate={setNav} />}
          {nav === "query" && <QueryEditor />}

          {activeReport && (() => {
            const Custom = CUSTOM_COMPONENTS[activeReport.componentType];
            return Custom
              ? <Custom key={activeReport.id} />
              : <ReportView key={activeReport.id} report={activeReport} />;
          })()}

          {nav === "tables" && !selectedTable && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60%", color: "var(--text-ghost)", gap: 12 }}>
              <div style={{ fontSize: 48 }}>🗃</div>
              <div style={{ fontSize: 16 }}>Sol panelden bir tablo seçin</div>
            </div>
          )}

          {nav === "tables" && selectedTable && (
            <TableExplorer schema={selectedTable.schema} table={selectedTable.table} />
          )}
          {nav === "crm" && <CrmModule />}
          {nav === "sozlesme" && <DestekSozlesme />}
          {nav === "kayitlar" && <DestekKayitlari />}
          {nav === "stok-gc" && <StokGelirGider />}
          {nav === "ekstre" && <CariEkstre />}
        </div>
      </main>
    </div>
  );
}
